import { sagaCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import { actions, actionTypes } from '../actions/mailTemplateAssoc';
import { selectors, DEFAULT_STATE } from '../reducers/mailTemplateAssoc';
import api from '../apis/mailTemplateAssoc';

const sagas = helper.createSagas('mailTemplateAssoc', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];